import React, { useCallback, useState, useEffect } from "react";
import {loadStripe} from '@stripe/stripe-js';
import Navbar from '../../Componenets/Navbar';


import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import { useNavigate , useLocation } from "react-router-dom";

const stripePromise = loadStripe("pk_test_51LBHZlD3bKBAJ7JYR7mdm55rp8g7UHvTPANhR2wih3CYqoAGit0GRwrDVBrGQ9yGh5IJsfWRgLaDYMaRZo3SckBr00JyR1Ydbt");

const Return = () => {
  const [status, setStatus] = useState(null);
  const [customerEmail, setCustomerEmail] = useState('');
  const navigate = useNavigate()

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get('session_id');

    fetch(`/session-status?session_id=${sessionId}`)
      .then((res) => res.json())
      .then((data) => {
        setStatus(data.status);
        setCustomerEmail(data.customer_email);
      });
  }, []);

  if (status === 'open') {
    return (
      navigate("/checkout")
    )
  }

  if (status === 'complete') {
    alert("success")
    return (
      <section id="success">
        <p>
          We appreciate your business! A confirmation email will be sent to {customerEmail}.
        </p>
      </section>
    )
  }

  return null;
}

const Checkout = () => {
  const location = useLocation();
  let sessionSecret = location?.state.clientSecret;
  console.log(sessionSecret)
  return (
    <div>
    
    <div
  style={{
    height: "auto", 
    width: "100%", 
    minWidth: "320px", 
    border: "none",
    marginTop : '5%',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "16px", 
    boxSizing: "border-box", 
  }}
>
  <div
    style={{
      width: "100%",
      height: "100%",
      border: "1px solid #e0e0e0", // Optional: Add a border for visual clarity
      borderRadius: "8px", // Optional: Add rounded corners
      overflow: "hidden", // Ensure the embedded content doesn't overflow
    }}
  >
    <EmbeddedCheckoutProvider
      stripe={stripePromise}
      options={{ clientSecret: sessionSecret }}
    >
      <EmbeddedCheckout />
    </EmbeddedCheckoutProvider>
  </div>
</div>
    </div>
  )
}

export default Checkout;